import React from 'react';
import {TextField} from 'material-ui';

const ImageMetaFields = ({
    classes,
    imageMeta,
    setAltField,
    setTitleField,
    setNameField,
    setDescriptionField,
    setLinkField,
}) => {
    return (
        <form className={classes.container} noValidate autoComplete="off">
            <TextField
                autoFocus
                margin="dense"
                id="alt"
                label="Alt Text"
                value={imageMeta.alt}
                fullWidth
                onChange={(event) => setAltField(event.target.value)}
                helperText="Used for SEO"
            />
            <TextField
                autoFocus
                margin="dense"
                id="title"
                label="Title Text"
                value={imageMeta.title}
                fullWidth
                onChange={(event) => setTitleField(event.target.value)}
                helperText="Used for SEO"
            />
            <TextField
                autoFocus
                disabled={true}
                margin="dense"
                id="title"
                label="File Name"
                value={imageMeta.name}
                fullWidth
                onChange={(event) => setNameField(event.target.value)}
                helperText="Not used right now"
            />
            <TextField
                margin="dense"
                id="description"
                label="Description"
                value={imageMeta.description}
                fullWidth
                onChange={(event) => setDescriptionField(event.target.value)}
                helperText="Used for galleries (at the bottom of the image)"
            />
            <TextField
                margin="dense"
                id="link"
                label="Link"
                value={imageMeta.link}
                fullWidth
                onChange={(event) => setLinkField(event.target.value)}
                helperText="Add full url or path to the page you want this image to be linked with"
            />
        </form>
    );
};

export default ImageMetaFields;



// WEBPACK FOOTER //
// ./src/containers/staff/forms/ImageMetaFields.jsx